/**
 * tdesign v1.9.0
 * (c) 2024 tdesign
 * @license MIT
 */

import { _ as _defineProperty } from '../_chunks/dep-b28084a7.js';
import React from 'react';
import '../config-provider/index.js';
import ConfigContext from '../config-provider/ConfigContext.js';
import '../_chunks/dep-86e19dfd.js';
import '../_chunks/dep-cdd61e41.js';
import '../config-provider/ConfigProvider.js';
import '../_chunks/dep-630f4ba0.js';
import '../_chunks/dep-00171999.js';
import '../_chunks/dep-bcc45390.js';
import '../_chunks/dep-44e4db9b.js';
import '../_chunks/dep-34380cbe.js';
import '../_chunks/dep-9b5d166c.js';
import '../_chunks/dep-bcd7851a.js';
import '../_chunks/dep-4645961d.js';
import '../_chunks/dep-ae74078c.js';
import '../_chunks/dep-1cca1a4a.js';
import '../_chunks/dep-0c50e0c6.js';
import '../_chunks/dep-9cc529e6.js';
import '../_chunks/dep-ee54d51d.js';
import '../_chunks/dep-eecdc06e.js';
import '../_chunks/dep-c85c2310.js';
import '../_chunks/dep-cecc0afd.js';
import '../_chunks/dep-a2c21e9b.js';
import '../_chunks/dep-db85742c.js';
import '../_chunks/dep-bf636c23.js';
import '../_chunks/dep-5461ebd0.js';
import '../_chunks/dep-a05643bf.js';
import '../_chunks/dep-feae8481.js';
import '../_chunks/dep-9f7e9722.js';
import '../_chunks/dep-f07fad21.js';
import './zh_CN.js';
import '../_common/js/global-config/locale/zh_CN.js';
import '../_chunks/dep-aeac2de2.js';
import 'dayjs';
import '../_chunks/dep-3d03053d.js';
import '../_common/js/global-config/default-config.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function useLocaleReceiver(componentName, defaultLocale) {
  var _React$useContext = React.useContext(ConfigContext),
    globalConfig = _React$useContext.globalConfig;
  function transformLocale(pattern, placement) {
    var REGEXP = /\{\s*([\w-]+)\s*\}/g;
    if (typeof pattern === "string") {
      if (!placement || !REGEXP.test(pattern)) return pattern;
      var translated = pattern.replace(REGEXP, function (_, key) {
        if (placement) return String(placement[key]);
        return "";
      });
      return translated;
    }
    if (Array.isArray(pattern)) {
      return pattern.map(function (p, index) {
        var translated = p.replace(REGEXP, function (_, key) {
          if (placement) return String(placement[index][key]);
          return "";
        });
        return translated;
      });
    }
    if (typeof pattern === "function") {
      return pattern(placement);
    }
    return "";
  }
  var componentLocale = React.useMemo(function () {
    var locale = defaultLocale || {};
    var connectLocaleByName = globalConfig[componentName];
    var localeFromContext = componentName && globalConfig ? connectLocaleByName : {};
    return _objectSpread(_objectSpread({}, typeof locale === "function" ? locale() : locale), localeFromContext || {});
  }, [componentName, defaultLocale, globalConfig]);
  return [componentLocale, transformLocale];
}

export { useLocaleReceiver };
//# sourceMappingURL=LocalReceiver.js.map
